import React from 'react'
import PropTypes from 'prop-types'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  render() {
    const { elm, k } = this.props

    return (
      <div key={k} className='mb-[15px] leading-[100%] relative'>
        <div className='w-[100%] bg-white rounded-[25px] flex gap-[10px]'>
          {elm?.image != '' &&
            <div className='flex-none relative'>
              <img 
                className='w-[101px] h-[auto]' 
                src={elm?.image} 
                alt={elm?.pagetitle} 
                width="101" 
                height="64" 
              />
            </div>
          }
          <div className='flex-1'>
            <div className='text-black text-[18px] font-medium mb-[5px]'>
              {elm?.pagetitle} в подарок{elm?.quantity > 1 ? ` x${elm?.quantity}` : ``}
            </div>
            <div className='text-[14px] text-[#00000099] mb-[8px] line-clamp-2'>{elm?.introtext}</div>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  elm: PropTypes.object,
  k: PropTypes.number
}

export default Main